export enum CategoryName {
  DiscoverByCategory = "DISCOVER BY CATEGORY",
  DiscoverByCollection = "DISCOVER BY COLLECTION",
  DiscoverByMainStone = "DISCOVER BY MAIN STONE",
  Men = "Men",
  Ladies = "Ladies",
  DiscoverByTypology = "Discover By Typology",
  DiscoverByAestheticLine = "Discover By Aesthetic Line",
  DiscoverByMovement = "Discover By Movement",

}
